import React from 'react';
import Logger from '../../util/Logger';
import ErrorPage from 'src/pages/ErrorPage';

export default class ErrorBoundary extends React.Component {

  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true });
    Logger.error(error, info);
  }

  render () {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorPage />;
    } else {
      return children;
    }
  }
}

